<template>
  <div class="store-menu">
    <div class="xl-logo">
      <img :src="web.logo" alt="">
    </div>
    <div class="web-title">
      {{web.name}}
    </div>
    <ul class="menu-item">
      <li class="item-li" v-for="(item,key) in data" :key="key" :class="{'sel-item-li':sel===key && !item.children.length,'color-li':sel===key && item.children.length}">
        <div class="item-title" @click="selIndex($event,key)">
          <i :class="'mar-r6 iconfont '+(item.icon)"></i>
          <span class="item-name">{{item.name}}</span>
          <i class="menu-down" :class="{'iconfont icon-xiala1':item.children.length}"></i>
        </div>
        <ul class="item-children" v-if="item.children.length">
          <li class="item-children-li" :class="{'sel-item-children-li':chiId===keys}" v-for="(items,keys) in item.children" :key="keys" @click="toChildren(items,keys)">
            <span>{{items.name}}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "StoreMenu",
    data() {
      return {
        sel:0,
        chiId:-1,
        data: [],
        web:{
          logo:'',
          name:''
        }
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        var _this = this;
        this.requestApi('/store/get_store_menu').then(function (res) {
          if (res.status) {
            _this.data = res.data
            _this.web  = res.web
          }
        })
      },
      //点击一级菜单
      selIndex(e,index){
        if (this.sel === index) this.sel = -1;
        else this.sel = index;
        this.chiId = -1;
        if(!this.data[index].children.length) {
          this.toUrl(this.data[index].url)
        }
      },
      toChildren(items,key){
        this.chiId = key;
        if(!items.url) return false;
        this.toUrl(items.url)
      }
    }
  }
</script>

<style scoped>
  .xl-logo{
    margin: 15px auto;
    width: 60px;
    height: 60px;
  }
  .xl-logo img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .store-menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 180px;
    height: 100%;
    font-size: 14px;
    text-align: left;
    color: hsla(0,0%,100%,.65);
    background: #001529;
    z-index: 99;
  }

  .menu-item {
    width: 100%;
    height: auto;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-li {
    height: auto;
  }
  .item-li:hover{
    cursor: pointer;
  }
  .item-title{
    display: flex;
    align-items: center;
    padding: 0 24px;
    height: 40px;
  }
  .item-name{
    flex: 2;
  }
  .item-title:hover span.item-name{
    color: #FFF;
  }
  .item-title:hover i{
    color: #FFF;
  }
  .sel-item-li{
    background-color: #1890ff;
  }
  .color-li .item-name,i{
    color: rgba(255,255,255,.65);
  }
  .color-li .menu-down{
    transform: rotate(180deg);
  }
  .sel-item-li span.item-name{
    color: #fff;
  }
  .sel-item-li i{
    color: #fff;
  }
  .item-children{
    display: none;
    list-style: none;
    margin: 0;
    padding: 0;
    background: #000c17;
  }
  .color-li .item-children{
    display: block!important;
  }
  .item-children-li{
    padding-left: 48px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
  }
  .sel-item-children-li{
    background-color: #1890ff;
  }
  .item-children-li:hover span{
    color: #FFF;
  }
  .mar-r6{
    margin-right: 6px;
  }
  .web-title{
    padding: 0 12px;
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/StoreMenu.vue